module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full",
    class: _vm.classLanceOnline
  }, [_c('div', {
    staticClass: "pregao-leiloeiro thema1 h-full",
    class: {
      'isLoading': _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "header-info0"
  }, [_c('div', {
    staticClass: "lote-num-label"
  }, [_c('div', {
    staticClass: "lote-numero"
  }, [_vm._v(_vm._s(_vm.posicao))]), _vm._v(" "), _c('div', {
    staticClass: "lote-num-qtd-leilao"
  }, [_vm._v(_vm._s(Number(_vm.lote.quantidadeLeiloes) + 1) + "º LEILÃO")])]), _vm._v(" "), _c('div', {
    staticClass: "hora"
  }, [_c('relogio')], 1), _vm._v(" "), _c('div', {
    staticClass: "comitente"
  }, [_c('img', {
    attrs: {
      "src": _vm.lote.comitente.imagemUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-info"
  }, [_c('div', {
    staticClass: "lote-details1",
    staticStyle: {
      "width": "100%",
      "padding": "0 20px"
    }
  }, [_c('div', {
    staticClass: "d-row"
  }, [_c('div', {
    staticClass: "d-col valor"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("LANCE ATUAL")]), _vm._v(" "), _c('div', {
    staticClass: "d-input valorAtual",
    class: {
      novoLance: _vm.hasNovoLance
    }
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-col arrematante",
    class: {
      online: _vm.apelido !== 'PLATEIA' && _vm.apelido !== '-'
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("ARREMATANTE")]), _vm._v(" "), _c('div', {
    staticClass: "d-input"
  }, [_c('strong', [_vm._v(_vm._s(_vm.apelido))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lanceLocalidade))])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-row"
  }, [_c('div', {
    staticClass: "d-col avaliacao"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Valor Avaliação")]), _vm._v(" "), _c('div', {
    staticClass: "d-input price"
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.lote.valorAvaliacao)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-col minimo",
    class: _vm.minimoStyle
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Valor Mínimo")]), _vm._v(" "), _c('div', {
    staticClass: "d-input price"
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.lote.valorMinimo)))])])]), _vm._v(" "), _vm._l((_vm.lote.lances), function(lance) {
    return _c('div', [_c('span', {
      staticClass: "hide"
    }, [_vm._v(" " + _vm._s(lance.valor))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "header-lote"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('div', {
    staticClass: "lote-nome",
    class: {
      'lote-sucata': _vm.lote.condicao === 7
    }
  }, [_vm._v(_vm._s(_vm.tituloLote))]), _vm._v(" "), _c('div', {
    staticClass: "lote-desc"
  }, [_vm._v("\n          " + _vm._s(_vm.descricaoLote) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "lote-obs"
  }, [_vm._v("\n          " + _vm._s(_vm.observacaoLote) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    class: 'lote-img-status' + _vm.lote.status
  }, [_c('img', {
    attrs: {
      "src": _vm.lote.imagem
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time-logo-fipe"
  }, [_c('div', {
    staticClass: "lote-details3 fipe"
  }, [_c('div', {
    staticClass: "fipe-lance"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fipe/Lance")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.fipeLance))])]), _vm._v(" "), _c('div', {
    staticClass: "fipe-title"
  }, [_vm._v("\n            % FIPE\n          ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Avaliação")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.porcentagemAvaliacao) + "%")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Minimo")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.porcentagemMinimo) + "%")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Tabela Fipe")]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorTabelaFipe)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "info-footer"
  }, [_c('a', {
    staticClass: "btn btn-default m-l m-b",
    on: {
      "click": _vm.voltar
    }
  }, [_vm._v("VOLTAR")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default m-r m-b",
    on: {
      "click": _vm.avancar
    }
  }, [_vm._v("AVANÇAR")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d7626b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-leiloeiro-patio/Main.vue
// module id = 1541
// module chunks = 17